var generateApplicationHeader = function (obj) {
    return Object.keys(obj)
        .map(function (key) { return "".concat(key, "=").concat(obj[key]); })
        .join('|');
};
export { generateApplicationHeader };
